/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Inbounds_To_DispatchInputs */

const en_queue_inbounds_to_dispatch = /** @type {(inputs: Queue_Inbounds_To_DispatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbounds to send to the warehouse`)
};

/**
* | output |
* | --- |
* | "Inbounds to send to the warehouse" |
*
* @param {Queue_Inbounds_To_DispatchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_inbounds_to_dispatch = /** @type {((inputs?: Queue_Inbounds_To_DispatchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Inbounds_To_DispatchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_inbounds_to_dispatch(inputs)
});